<template>
  <div class="w-full" :class="{ 'animation-wrapper': naanAmountEqual4 }">
    <div class="w-full max-display-card flex flex-col items-center">
      <div class="text-center font-medium text-1xl px-10 ">
        <span :class="{ 'text-white': naanAmountEqual4 }"
          >You should order
        </span>
      </div>
      <div class="text-center font-bold text-6xl px-10 leading-none py-6">
        <span :class="{ 'text-white': naanAmountEqual4 }">
          {{ naanAmount }} naan
        </span>
      </div>
      <insane-animation-component v-if="naanAmountEqual4" />
      <div class="text-center max-display">
        <description-result-component :naanAmount="naanAmount" />
      </div>
      <div
        class="w-full px-20 py-6 font-medium text-center px-8 lg:px-48 md:px-48"
      >
        <span :class="{ 'text-white': naanAmountEqual4 }">
          That's {{ dividePerPerson }} per person, a sensible amount for your
          group size
        </span>
      </div>
    </div>
    <transition name="slide-fade1" appear>
      <div class="w-full max-display flex justify-center">
        <naan-svg-component
          :naan-amount="naanAmount"
          class="overflow-x-hidden"
          :class="{ 'img-animation': naanAmountEqual4 }"
        />
      </div>
    </transition>
    <x-footer :text-color="changeFooterColor" />
  </div>
</template>
<script>
import XFooter from "@/components/Footer/XFooter";
import InsaneAnimationComponent from "@/components/ScreenComponents/InsaneAnimationComponent";
import DescriptionResultComponent from "@/components/ScreenComponents/DescriptionResultComponent";
import NaanSvgComponent from "@/components/ScreenComponents/NaanSvgComponent";

export default {
  name: "ResultComponent",
  components: {
    NaanSvgComponent,
    DescriptionResultComponent,
    XFooter,
    InsaneAnimationComponent
  },
  props: {
    naanAmount: {
      type: Number
    },
    personsAmount: {
      type: Number
    },
    changeFooterColor: {
      type: Boolean
    }
  },
  computed: {
    naanAmountEqual4() {
      return this.naanAmount === 4;
    },
    displayNaanImage() {
      if (this.naanAmount >= 5) {
        return 5;
      } else {
        return this.naanAmount;
      }
    },
    dividePerPerson() {
      return (this.naanAmount / this.personsAmount).toFixed(1);
    }
  }
};
</script>
<style scoped>
.animation-wrapper {
  animation: shake 0.5s;
  animation-iteration-count: 4;
}

.img-animation {
  animation: scale-img 5s;
}

@keyframes scale-img {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.4);
  }
  40%,
  100% {
    transform: scale(1);
  }
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
